/**
 * `offer.loyalty.hasPackageTypeUpgrades` / `hasRoomTypeUpgrades` are derived from package metadata
 * alone, so they stay true for an offer whose upgradable packages are sold out. Once a stay is
 * selected the package views carry calendar-backed availability, including whether the upgrade
 * target itself is sellable on those dates (`loyaltyUpgradeAvailability`), so prefer them over the
 * offer metadata to avoid advertising an upgrade that cannot be booked.
 */
export function hasAvailableLoyaltyStayUpgrade(
  offerLoyalty: App.HotelOfferLoyaltyConfig,
  packageViews: Array<App.OfferPackageOptionView> | undefined,
  checkIn: string | undefined,
): boolean {
  const hasUpgradablePackages = offerLoyalty.hasPackageTypeUpgrades || offerLoyalty.hasRoomTypeUpgrades
  // Without a selected stay there are no dates to check availability against, so the offer metadata
  // is all we have to advertise from.
  if (!hasUpgradablePackages || !checkIn || !packageViews) return hasUpgradablePackages
  return packageViews.some(view =>
    view.hotelAvailable &&
    // `availableRooms` is undefined until calendar or rate data lands, so only an explicit 0 is
    // sold out - treating the loading state as sold out would hide the pill on every first render.
    view.availableRooms !== 0 &&
    !!view.loyaltyUpgradeAvailability,
  )
}
